import { ApolloProvider } from '@apollo/client'
import { ConfigProvider } from 'antd'
import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { renderRoutes } from 'react-router-config'
import { Router } from 'react-router-dom'
import { createChildHistory, prefixRoutes } from '~/child-history'
import appRoutes from '~/routes'

const queryClient = new QueryClient()

const App = ({ basename, history, apolloClient, children }: any) => {
  const prefixedRoutes = prefixRoutes(basename, appRoutes())
  const childHistory = createChildHistory({ history, basename })

  const themeConfig: any = {
    token: {
      fontFamily: '"Open Sans", Arial, sans-serif',
      colorPrimary: '#005587',
      borderRadius: '6px',
      colorBgBase: '#FFFFFF',
    },
  }

  return (
    <Router history={childHistory}>
      <ConfigProvider theme={themeConfig}>
        <QueryClientProvider client={queryClient}>
          <ApolloProvider client={apolloClient}>
            {children ? children : renderRoutes(prefixedRoutes)}
          </ApolloProvider>
        </QueryClientProvider>
      </ConfigProvider>
    </Router>
  )
}

export default App
